export default __webpack_public_path__ + "static/media/background-large.b43fb86c.png";